// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import TableOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
import DashboardOutlined from '/vercel/path0/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
export default { SmileOutlined, CrownOutlined, TableOutlined, DashboardOutlined };
